import { render, staticRenderFns } from "./Exception.vue?vue&type=template&id=776b32c8"
import script from "./Exception.vue?vue&type=script&lang=js"
export * from "./Exception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports